export type LoggerPayload = string | { [name: string]: unknown };

export abstract class Logger {
    abstract log(title: string, payload?: LoggerPayload): void;
    abstract debug(title: string, payload?: LoggerPayload): void;
    abstract info(title: string, payload?: LoggerPayload): void;
    abstract warn(title: string, payload?: LoggerPayload): void;
    abstract error(error: unknown, payload?: LoggerPayload): void;
    abstract critical(error: unknown, payload?: LoggerPayload): void;
}
